import { render } from "./demo-day-founder-card.vue?vue&type=template&id=be8bc090"
import script from "./demo-day-founder-card.vue?vue&type=script&lang=js"
export * from "./demo-day-founder-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__